export default function ContentFeedLoadingSkeleton() {
    return (
        <div className="w-52 animate-pulse rounded-[10px] border border-ink-200 bg-white px-3.5 py-3">
            <div className="h-3 w-3/4 rounded bg-ink-200"></div>
            <div className="mt-2.5 h-6 w-1/3 rounded bg-ink-200"></div>
        </div>
    )
}

export function ContentFeedKPILoadingSkeleton() {
    return (
        <div className="flex w-16 animate-pulse flex-row items-stretch">
            <div className="h-7 w-full rounded bg-ink-200"></div>
        </div>
    )
}
